import React, { Suspense } from 'react'
import { Loading } from '../index'

const MainSuspense = ({ children }) => {
    return <Suspense fallback={<Loading />}>{children}</Suspense>
}

export default MainSuspense
